import React from "react";
import { Store } from "../../contexts/Store";

export default function Price (props) {
  const config = Store.useState(s => s.config);
  const symbol = props.currencySymbol || config.currencySymbol;
  const position = props.position || (config ? config.getProperty("information", "currencySymbolPosition") : "before");

  return (
    <span className={`price ${props.className || ""}`}>
      {position === "before" ? (
        <>
          {symbol}
          {props.value}
        </>
      ) : (
        <>
          {props.value}
          {symbol}
        </>
      )}
    </span>
  );
}
